export default {
  root: ({ props, context }) => ({
    class: [
      'relative shrink-0',
      'text-[12px] md:text-[14px] xl:text-[16px] uppercase leading-[150%] font-medium',
      'flex items-center',

      {
        'flex-1 justify-center': props.ptOptions?.variant === 'stretch'
      },

      // Spacing
      'py-2 xl:py-3 px-1 xl:px-2 space-x-2 xl:space-x-3',
      'mr-4 xl:mr-6',

      // Colors and Conditions
      'outline-transparent',
      // 'border-solid border-b-[2px] hover:border-surface-900',
      {
        'border-transparent dark:border-surface-700': !context.active,
        // 'bg-surface-0 dark:bg-surface-900': !context.active,
        'text-surface-900 dark:text-surface-0/80': !context.active,
        'dark:bg-surface-900': context.active,
        'text-primary-600': context.active,
        'opacity-60 cursor-default user-select-none select-none pointer-events-none': props == null ? void 0 : props.disabled
      },

      // Transitions
      'transition-all duration-200',

      // Misc
      'cursor-pointer select-none whitespace-nowrap',
      'user-select-none',

      // Icon
      '[&>i]:text-[18px] xl:[&>i]:text-[22px]'
    ]
  })
}